<template>
  <div class="cards-search">
    <div class="notification">
      <b-field :label="'Пошук по номеру картки або телефона'">
        <b-input v-model="value" />
      </b-field>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";

export default {
  name: 'SearchCards',

  computed: {
    value: {
      get () {
        const query = this.$route.query || {}

        return query.search || ''
      },

      set (val) {
        this.onSearch(val)
      }
    }
  },

  methods: {
    onSearch: debounce(async function debouncedInput(query) {
      this.$router.replace({
        query: {
          search: query
        }
      })

      this.$emit('fetch')
    }, 500),
  }
}
</script>

<style lang="scss">
  .cards-search {
    margin-bottom: 16px;
  }
</style>
